<template>

  <section class="mt-4 sm:mt-24 sm-max:mt-12 px-16 sm-max:px-5">


    <div class="">

      <div class="">

        <div class="md:float-right md:inline md:mb-8 md-max:pb-4 lg:ml-6">

          <nuxt-img
              class="m-auto md:ml-10 sm-max:w-32"
              width="294"
              height="306"
              loading="lazy"
              format="webp"
              :alt="imageAlt"
              :src="imageSrc"
          ></nuxt-img>


          <div class="justify-center">
            <div class="text-center sm-max:text-xs text-lg leading-6" v-html="imageName">

            </div>

            <div class="text-center sm-max:text-xs text-lg leading-6" v-html="imageWork">

            </div>
          </div>

        </div>

        <h3 class="font-bold lg:text-21 md:text-lg text-base" v-html="textTitle"></h3>
        <div class="lg:text-21 md-max:pr-5 md:text-lg text-15 pt-4 leading-6 lg:leading-7 2xl:mr-98">
<div class="" v-html="text1">

</div>

          <br/>
        <div class="" v-html="text2">

        </div>

        </div>


        <ul class="list-disc pl-10 sm-max:mt-2 mt-6 space-y-2 sm-max:text-base pr-2">

          <li v-for="(item, index) in multipleBenefits"
                :key="index" v-html="item.text" class="lg:text-21 md:text-lg text-15 md:leading-6 lg:leading-7 sm-max:!mt-0 !mt-0">

          </li>


        </ul>

        <div class="mt-8 lg:text-21 md:text-lg text-15 md:leading-6 lg:leading-7" v-html="text3">

        </div>

        <div class="mt-6 lg:text-21 md:text-lg text-15 md:leading-6 lg:leading-7" v-html="text4">

        </div>

        <div class="mt-6 lg:text-21 md:text-lg text-15 md:leading-6 lg:leading-7" v-html="text5">

        </div>

        <div class="mt-6 lg:text-21 md:text-lg text-15 md:leading-6 lg:leading-7" v-html="text6">

        </div>

      </div>

      <!--      <div class="text-center">-->

      <!--        <nuxt-img-->
      <!--            class="m-auto"-->
      <!--            loading="lazy"-->
      <!--            format="webp"-->
      <!--            alt="Dr Aaron Oxenrider"-->
      <!--            sizes="sm:440px  md:100vw lg:100vw xl:524px"-->
      <!--            src="/assets/images/aron-profile-img.jpg"-->
      <!--        ></nuxt-img>-->


      <!--        <div class="text-ratingYellow text-3xl pt-8">★★★★★</div>-->

      <!--        <div class="text-2xl mb-8">-->
      <!--          "Lifeboost is by far the smoothest, most delicious coffee I've ever tasted. Whether I'm using intermittent-->
      <!--          fasting or just need a burst of energy and focus for my intense work load, Lifeboost delivers the cleanest,-->
      <!--          purest coffee energy you can find. I look forward to my daily cup (or two) each day to help boost my immune-->
      <!--          health and increase my productivity."-->
      <!--        </div>-->

      <!--        <h3 class="text-3xl font-roboto">Shaun Hadsall</h3>-->
      <!--        <h4 class="text-2xl">Owner of GetLeanAfter40</h4>-->
      <!--      </div>-->




    </div>

  </section>

</template>
<style>
.swiper-wrapper {
  width: 100%;
  height: 100%;
}
.swiper-button-next{
  @apply !text-productTitle sm-max:pl-2 pt-8

}

.swiper-button-prev {
  @apply !text-productTitle sm-max:pr-2 pt-8
}
.swiper-button-next:after,.swiper-button-prev:after {
  font-size: 23px;
  font-weight: 800;
}
</style>
<script setup>


const props = defineProps({
  textTitle: {
    type: String,
    default: 'From the desk of Dr. Charles Livingston:',
  },
  text1: {
    type: String,
    default: 'Johns Hopkins Medicine recently reported that, according to the Dietary Guidelines for Americans, “it’s safe for most people to drink three to five cups of coffee a day with a maximum intake of 400 milligrams of caffeine.” (source)',
  },
  text2: {
    type: String,
    default: 'They reported multiple benefits of drinking coffee, including the following:',
  },
  text3: {
    type: String,
    default: 'With all these benefits, however, there’s a big risk in drinking coffee: pesticides, mycotoxins, and molds.',
  },
  text4: {
    type: String,
    default: 'One research study found that 91.7% of the coffee samples they tested contained molds.',
  },
  text5: {
    type: String,
    default: 'So what do you do?',
  },
  text6: {
    type: String,
    default: 'This coffee is clean, healthy, non-GMO, and as pure as you can get with just one simple ingredient:',
  },
  imageSrc: {
    type: String,
    default: '/dr_img.png',
  },
  imageAlt: {
    type: String,
    default: 'Dr. Charles Livingston,',
  },
  imageName: {
    type: String,
    default: 'Dr. Charles Livingston,',
  },
  imageWork: {
    type: String,
    default: 'Natural Health Expert',
  },
  multipleBenefits: {
    type: Array,
    default: () => [
      { text: 'Coffee drinkers are less likely to die from some of the leading causes of death.' },
      { text: 'Coffee...contains antioxidants and other active substances that may reduce internal inflammation and protect against disease.' },
      { text: 'Dark roast coffee decreases breakage in DNA strands, which occur naturally but can lead to cancer or tumors if not repaired by your cells.' },
      { text: '...coffee drinkers - decaf or regular - were 26 percent less likely to develop colorectal cancer.' },
      { text: 'Coffee is chock full of substances that may help guard against...Alzheimer\'s disease and heart disease.' },
    ],
  },
});


defineBuilderComponent({
    friendlyName: "FromDesk",
    canHaveChildren: true,
    inputs: [
        {
            name: "textTitle",
            type: "string",
            defaultValue: "From the desk of Dr. Charles Livingston:"
        },
        {
            name: "text1",
            type: "richText",
            defaultValue: " Johns Hopkins Medicine recently reported that, according to the Dietary Guidelines for Americans, “it’s safe for most people to drink three to five cups of coffee a day with a maximum intake of 400 milligrams of intake of 400 milligrams of caffeine.” (source)"
        },
        {
            name: "text2",
            type: "richText",
            defaultValue: "They reported multiple benefits of drinking coffee, including the following:"
        },
        {
            name: "text3",
            type: "richText",
            defaultValue: "With all these benefits, however, there’s a big risk in drinking coffee: pesticides, mycotoxins, and molds."
        },
        {
            name: "text4",
            type: "richText",
            defaultValue: "One research study found that 91.7% of the coffee samples they tested contained molds.(source)"
        },
        {
            name: "text5",
            type: "richText",
            defaultValue: "So what do you do?"
        },
        {
            name: "text6",
            type: "richText",
            defaultValue: " This coffee is clean, healthy, non-GMO, and as pure as you can get with just one simple ingredient:"
        },
        {
            name: "multipleBenefits",
            type: "list",
            subFields: [
                {
                    name: "text",
                    type: "richText",
                    defaultValue: ""
                }
            ],
            defaultValue: [
                {
                    text: "Coffee drinkers are less likely to die from some of the leading causes of death."
                },
                {
                    text: "Coffee...contains antioxidants and other active substances that may reduce internal inflammation and protect against disease."
                },
                {
                    text: "Dark roast coffee decreases breakage in DNA strands, which occur naturally but can lead to cancer or tumors if not repaired by your cells."
                },
                {
                    text: "...coffee drinkers - decaf or regular - were 26 percent less likely to develop colorectal cancer."
                },
                {
                    text: "Coffee is chock full of substances that may help guard against...Alzheimer's disease and heart disease."
                }
            ]
        },
        {
            name: "imageSrc",
            type: "file",
            allowedFileTypes: [
                "jpeg",
                "jpg",
                "png",
                "svg"
            ],
            defaultValue: "/dr_img.png"
        },
        {
            name: "imageAlt",
            type: "text",
            defaultValue: "Dr. Charles Livingston,"
        },
        {
            name: "imageName",
            type: "richText",
            defaultValue: "Dr. Charles Livingston,"
        },
        {
            name: "imageWork",
            type: "richText",
            defaultValue: "Natural Health Expert"
        },
        {
            name: "slides",
            type: "list",
            subFields: [
                {
                    name: "imgSrc",
                    type: "file",
                    allowedFileTypes: [
                        "jpeg",
                        "jpg",
                        "png",
                        "svg"
                    ],
                    defaultValue: ""
                },
                {
                    name: "imgAlt",
                    type: "string",
                    defaultValue: ""
                },
                {
                    name: "rating",
                    type: "string",
                    defaultValue: ""
                },
                {
                    name: "testimonial",
                    type: "string",
                    defaultValue: ""
                },
                {
                    name: "name",
                    type: "string",
                    defaultValue: ""
                },
                {
                    name: "title",
                    type: "string",
                    defaultValue: ""
                }
            ],
            defaultValue: []
        }
    ]
});
</script>